import React from "react";
import ReactHtmlParser from 'react-html-parser';
import { Button, Row, Container, Card, Glyph, FormField, Radio, Alert } from "kepler";
import WhatIsTechSoup from '../components/whatIsTechSoupModal';
import { parseMessages } from '../../../utilityHelper';
import { DIRECTMODEL_COUNTRIES } from "../../../../../constants/constants";

const templateData = $('body').data(),
    countryCode = templateData.country,
    propertyInfo = parseMessages('ppcc/confirmation/confirmation-home'),
    ratesResult = templateData.ratesResult;
let ppccTxnRate = ratesResult ? (`${ratesResult.ppccTxnRate_percent} + ${ratesResult.ppccCharityRate}`) : '';

export default class GetStarted extends React.Component {
    render() {

        let getStartedList1 = (propertyInfo && propertyInfo.getStarted.li1) ? propertyInfo.getStarted.li1.replace('{ppccTxnRate}', ppccTxnRate) : '',
            getStartedList2 = (DIRECTMODEL_COUNTRIES.indexOf(countryCode) >= 0) ? propertyInfo.getStarted.DMli2 : propertyInfo.getStarted.li2;

        return (
            <Container
                id="getStarted"
                maxWidth={800}
                className="container"
            >
                <Row>
                    <Card className="roundedBox">
                        <div className="bodyContainer">
                            <h3>{propertyInfo.getStarted.h3}</h3>
                            <p className="">{propertyInfo.getStarted.p}</p>
                            <ul>
                                <li>{getStartedList1}</li>
                                <li>{getStartedList2}</li>
                            </ul>
                            <Button href="/charities/dashboard" id="confirmAccount">{propertyInfo.getStarted.continue}</Button>
                        </div>
                    </Card>
                </Row>
            </Container>
        );
    }
}

export class Inprogress extends React.Component {
    render() {
        return (
            <Container
                id="ConfirmCharityWapper"
                maxWidth={800}
                className="container"
            >
                <Row>
                    <Card id="setupConfirmation" className="roundedBox">
                        <div className="bodyContainer">
                            <p className="emailWrap"><span className="icon icon-email icon-large" aria-hidden="true"></span></p>
                            <h3>{propertyInfo.inprogress.title}</h3>
                            <p className="vx_text-body-md successmessage">{propertyInfo.inprogress.message}</p>
                            <p className="vx_text-3">
                                <Button href="/" type="primary" className="continueBtn">{propertyInfo.success.continuemsg}</Button>
                            </p>
                            <p>
                                <a href="/smarthelp/contact-us">{propertyInfo.reach.contact}</a>
                            </p>
                        </div>
                    </Card>
                </Row>
            </Container>
        );
    }
}

export class SomethingWentWrong extends React.Component {
    render() {
        return (
            <Container
                id="ConfirmCharityWapper"
                maxWidth={800}
                className="container"
            >
                <Row>
                    <Card id="setupConfirmation" className="roundedBox">
                        <div className="bodyContainer">
                            <p className="textcenter attention"><Glyph icon="icon-attention-small" /></p>
                            <h3>{propertyInfo.somethingwentwrong.message1}</h3>
                            <h4>{propertyInfo.somethingwentwrong.message2}</h4>
                        </div>
                    </Card>
                </Row>
            </Container>
        );
    }
}

export class InValidCharityType extends React.Component {
    render() {
        let countryCode = this.props.countryCode;
        return (
            <Container
                id="ConfirmCharityWapper"
                maxWidth={800}
                className="container craWarning"
            >
                <Row>
                    <Card id="setupConfirmation" className="roundedBox">
                        <div className="bodyContainer">
                            <p className="textcenter attention"><Glyph icon="icon-attention-small" /></p>
                            <h3>{propertyInfo.craWarning.title}</h3>
                            {countryCode === 'CA' ? (
                                <div>
                                    <p className="vx_text-body-md body_text shadeColor">{propertyInfo.craWarning.bodytext}</p>
                                    <Button href={this.props.profileLink} type="primary" className="continueBtn">{propertyInfo.craWarning.profileLink}</Button>
                                    <p className="body_text"><a href="/">{propertyInfo.craWarning.accontBtn}</a></p>
                                </div>
                            ) :
                                (
                                    <div>
                                        <p className="vx_text-body-md body_text shadeColor">{propertyInfo.charityStaus.errMsg}</p>
                                    </div>
                                )}
                        </div>
                    </Card>
                </Row>
            </Container>
        );
    }
}

export class Revoked extends React.Component {

    render() {
        return (
            <Container
                id="ConfirmCharityWapper"
                maxWidth={800}
                className="container"
            >
                <Row>
                    <Card id="setupConfirmation" className="roundedBox">
                        <div className="bodyContainer">
                            <p className="textcenter attention"><Glyph icon="icon-attention-small" /></p>
                            <h3>{propertyInfo.revoked.title}</h3>
                            <p className="vx_text-body-md successmessage">{ReactHtmlParser(propertyInfo.revoked.message)}</p>
                        </div>
                    </Card>
                </Row>
            </Container>
        );
    }
}

export class Success extends React.Component {
    render() {

        let successMsg2 = (propertyInfo && propertyInfo.success.message2) ? propertyInfo.success.message2.replace('{ppccTxnRate}', ppccTxnRate) : '';

        return (
            <Container
                id="ConfirmCharityWapper"
                maxWidth={800}
                className="container"
            >
                <Row>
                    <Card id="setupConfirmation" className="roundedBox">
                        <div className="bodyContainer">
                            <p className="textcenter"><img src="https://www.paypalobjects.com/webstatic/ppgf/check.png" /></p>
                            <h3>{propertyInfo.success.message1}</h3>
                            <p className="vx_text-body-md successmessage">{successMsg2}</p>
                            <Button href="/" type="primary" className="continueBtn">{propertyInfo.success.continuemsg}</Button>
                        </div>
                    </Card>
                </Row>
            </Container>
        );
    }
}

export class ChooseCharityType extends React.Component {
    render() {
        let countryCode = this.props.countryCode;
        
        return (
            <Container 
                id="ConfirmCharityWapper"
                maxWidth={800}
                className="container"
            >
                <Row>
                    <Card id="setupConfirmation" className="roundedBox">
                        <div className="bodyContainer">
                            <h3>{propertyInfo.chooseCT.headline1}</h3>
                            <Alert className="errorMsg" type="error">{propertyInfo.chooseCT.errMsg}</Alert>
                            <FormField label={propertyInfo.chooseCT.headline2}>
                                {countryCode === 'BR' ? (
                                    <div>
                                        <Radio name="charityType" value="BR_CEBAS" label={propertyInfo.chooseCT.type.br1} onChange={this.props.handleChange} />
                                        <Radio name="charityType" value="BR_OS" label={propertyInfo.chooseCT.type.br2} onChange={this.props.handleChange} />
                                        <Radio name="charityType" value="BR_OSCIP" label={propertyInfo.chooseCT.type.br3} onChange={this.props.handleChange} />
                                        <Radio name="charityType" value="BR_UPF" label={propertyInfo.chooseCT.type.br4} onChange={this.props.handleChange} />
                                        <Radio name="charityType" value="BR_OTHER" label={propertyInfo.chooseCT.type.br5} onChange={this.props.handleChange} />
                                    </div>
                                ) : (
                                        <div>
                                            <Radio name="charityType" value="MX_OSC" label={propertyInfo.chooseCT.type.mx1} onChange={this.props.handleChange} />
                                            <Radio name="charityType" value="MX_SAT" label={propertyInfo.chooseCT.type.mx2} onChange={this.props.handleChange} />
                                            <Radio name="charityType" value="MX_OTHER" label={propertyInfo.chooseCT.type.mx3} onChange={this.props.handleChange} />
                                        </div>
                                    )}
                            </FormField>
                            <Button onClick={this.props.submitCharityType} type="primary" className="continueBtn">{propertyInfo.chooseCT.continuemsg}</Button>
                        </div>
                    </Card>
                </Row>
            </Container>
        );
    }
}

export class NotStarted extends React.Component {

    render() {
        return (
            <Container
                id="ConfirmCharityWapper"
                maxWidth={800}
                className="container"
            >
                <Row>
                    <Card id="setupConfirmation" className="roundedBox">
                        <div className="bodyContainer">
                            <p className="titleImg"><img src="https://www.paypalobjects.com/webstatic/ppgf/ppcc/PP_logo.svg" width="150px" /><img src="https://www.paypalobjects.com/webstatic/ppgf/ppcc/techsoup-logo.svg" width="150px" /></p>
                            <h3>{propertyInfo.confirm.title}</h3>
                            <p className="vx_text-body-md body_text">{propertyInfo.confirm.p1} <a onClick={this.props.toggleModal}>{propertyInfo.confirm.whatistechsoup}</a></p>
                            <p className="vx_text-body-md body_text">{propertyInfo.confirm.p2}</p>
                            <p className="vx_text-3">
                                <Button onClick={this.props.viewTokenCollection}>{propertyInfo.confirm.usetechsoup}</Button>
                            </p>
                            <p className="divideWithOr"><span>{propertyInfo.tokencollect.or}</span></p>
                            <p className="vx_text-3">
                                <Button type="secondary" href="/givingfund/ppcc/consent">{propertyInfo.confirm.requesttechsoup}</Button>
                            </p>
                        </div>
                        <WhatIsTechSoup isOpen={this.props.modalIsOpen} />
                    </Card>
                </Row>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./ppcc/confirmation/components/getStarted.js